var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBuilderContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.678,
    height: 45.673,
    viewBox: "0 0 45.678 45.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_7-Phone",
    transform: "translate(-9.689 -9.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55648",
    "data-name": "Path 55648",
    d: "M53.153,43.458l-6.632-4.633a5.114,5.114,0,0,0-7.128,1.268L37.853,42.3a57.028,57.028,0,0,1-8.2-6.891,56.955,56.955,0,0,1-6.89-8.2l2.205-1.54a5.112,5.112,0,0,0,1.268-7.129L21.6,11.9a5.124,5.124,0,0,0-4.182-2.213,4.8,4.8,0,0,0-1.666.3,9.183,9.183,0,0,0-1.725.847l-.916.645a6.942,6.942,0,0,0-.646.577,9.2,9.2,0,0,0-2.357,4.2C8.2,23.415,12.928,34.235,21.875,43.182c7.514,7.514,16.54,12.181,23.556,12.182h0a13.069,13.069,0,0,0,3.367-.416A9.2,9.2,0,0,0,53,52.591a6.962,6.962,0,0,0,.6-.685l.645-.921a9.221,9.221,0,0,0,.817-1.679,5.038,5.038,0,0,0-1.916-5.848Z",
    transform: "translate(0)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderContacts);
export default __webpack_public_path__ + "static/media/profile-builder-contacts.b46a32c72d882ee313eb1959b4a2a2d9.svg";
export { ForwardRef as ReactComponent };